var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1GangPullCord01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3.9,
    cy: 9.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.1,9 12.1,5 5.3,9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.6,7.8c0.2,0.1,1.6,1.6,1.6,1.6l1.4-1.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1GangPullCord01);
export default __webpack_public_path__ + "static/media/1GangPullCord-01.2e18b07e457cc201f6c1dfc52f895b24.svg";
export { ForwardRef as ReactComponent };